import type ReconnectingWeb from 'reconnecting-websocket'
import EventEmitter from 'eventemitter3'

export class WebsocketEventEmitter extends EventEmitter<string, void> {
  public connected = ref(false)
  #socket: ReconnectingWeb

  public constructor(socket: ReconnectingWeb, login: { token: string, tenant: string, displayName: string }) {
    super()

    this.#socket = socket

    socket.onopen = () => {
      console.log('websocket connected')
      this.emit('login', login.token, login.tenant, login.displayName)
      this.connected.value = true
    }

    socket.onclose = () => {
      console.log('websocket close')
      this.connected.value = false
    }

    socket.onmessage = (event) => {
      console.log('websocket receive', event.data)
      const d = JSON.parse(event.data)
      if (Array.isArray(d) && d.length > 0)
        super.emit(d[0], ...d.slice(1))
    }
  }

  override emit(...args: any[]): boolean {
    console.log('websocket send', args)
    this.#socket.send(JSON.stringify(args))
    return true
  }
}
